import { render } from "./Popup.vue?vue&type=template&id=5d97b0d4&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Popup.vue?vue&type=style&index=1&id=5d97b0d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d97b0d4"

export default script